var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundCircle1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 329,
    viewBox: "0 0 309 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.5 329C317.442 329 409 237.442 409 124.5C409 11.5578 317.442 -80 204.5 -80C91.5578 -80 0 11.5578 0 124.5C0 237.442 91.5578 329 204.5 329ZM204.501 238.639C267.538 238.639 318.64 187.537 318.64 124.5C318.64 61.4624 267.538 10.3604 204.501 10.3604C141.463 10.3604 90.3613 61.4624 90.3613 124.5C90.3613 187.537 141.463 238.639 204.501 238.639Z",
    fill: "#F6F3FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundCircle1);
export default __webpack_public_path__ + "static/media/background_circle_1.511a47bf08a3a48165fbe30d95cd1bb9.svg";
export { ForwardRef as ReactComponent };